/* unplugin-vue-components disabled */import script from "./NoDevice.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoDevice.vue?vue&type=script&lang=ts&setup=true"

import "./NoDevice.vue?vue&type=style&index=0&id=5d878700&lang=less&scoped=true"

import exportComponent from "/work/release/ug-fe-contest-student/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d878700"]])